import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import $ from 'jquery';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import forgotpwdIcon from '../../images/icons/forgotpwdicon.png';


var fpServerResponses = {
      200: 'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',
      403: 'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',
      600: 'Invalid User ID / Email.', // also for 400, 401
      0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'
    };

class UnifiedForgotPwd extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {	
				plp_userinput: this.props.userid || "",
				username_newacc: '',
				password_newacc: '',
				confirmpassword_newacc: '',
				singupType:"userid",
				loginType:this.props.loginType || "userid",
				userInput:this.props.userInput || "",
				otp_newacc: '',				
				submitButtonDisabled: false,
				serverMessage: "",
				emailfeedbackmsg: "",
				source:"",
				isOTPSend:false,
				isVerified:false,
				OTPDisabled:"hiddenOTP",
				verifyDisabled:"disabled",
				emailDisabled:false,
				phoneDisabled:false,
				verifyText:this.rb("register.verify"),
				sendOTPText:this.rb("home.continue"),
				pwdUpdated:false,
				passcodeDisabled:"disabled",
				username: '',
				UseridEmailidSame:false,
				user_exists:false
		};

		this.handleChange = this.handleChange.bind(this);		
		this.enterOTPChange = this.enterOTPChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitVerify=this.handleSubmitVerify.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.userverifyIdChange = this.userverifyIdChange.bind(this);

		this.sendOTP = this.sendOTP.bind(this);
		this.verifyOTP = this.verifyOTP.bind(this);
		this.getOTPField = this.getOTPField.bind(this);
		this.showLogin = this.showLogin.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		
		this.myTrackerInstance = this.getTracker();

		this.handleemailChange = this.handleemailChange.bind(this);
		this.submitLumosPwdForm = this.submitLumosPwdForm.bind(this);
		this.submitPLPPwdForm = this.submitPLPPwdForm.bind(this);
		this.submitCommonPwdForm = this.submitCommonPwdForm.bind(this);
		this.renderUseridEmailidValue = this.renderUseridEmailidValue.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		
		this.plpForgotPassword=this.plpForgotPassword.bind(this);
		this.lumosForgotPassword=this.lumosForgotPassword.bind(this);
		this.commonForgotPassword=this.commonForgotPassword.bind(this);
		this.forgotPassword=this.forgotPassword.bind(this);
		this.renderRHSForm=this.renderRHSForm.bind(this);
		this.userVerify=this.userVerify.bind(this);
		this.getUserStatus=this.getUserStatus.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		var me = this;
        //console.log('componentWillReceiveProps', nextProps);    
        this.setState({	
				loginType:nextProps.loginType || "userid",
				userInput:nextProps.userInput || "",
				otp_newacc: '',				
				submitButtonDisabled: false,
				serverMessage: "",
				emailfeedbackmsg: "",
				source:"",
				isOTPSend:false,
				isVerified:false,
				OTPDisabled:"hiddenOTP",
				verifyDisabled:"disabled",
				emailDisabled:false,
				phoneDisabled:false,
				verifyText:this.rb("register.verify"),
				sendOTPText:this.rb("home.continue"),
				pwdUpdated:false,
				passcodeDisabled:"disabled"
		});
        setTimeout(function(){
  			me.reinitiate();
  		},500)
        
    }
	componentDidMount(){
		this.sessionCheck();
		this.reinitiate();		
	} 

	reinitiate(){
		if(this.state.userInput != ""){
			this.form.validateFields();
			this.setState({ submitButtonDisabled: !this.form.isValid() });
			
			if(this.form.isValid()){
				this.setState({ OTPDisabled: ""});
				$(".OTPButton").trigger("click");
			}
		}
		
		$("#loginRoot .userInput").focus();
	}

	handleChange(e) {
		const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}
	handleemailChange(e) {    
		this.handleChange(e);
	}


	userIdChange(e){
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		// if(phoneRegx.test(target.value)){
		// 	this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
		// 	if(target.value.length >= 10){				
		// 		this.setState({ OTPDisabled: "", passcodeDisabled:""});
		// 	}
		// }else{
		// 	this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
		// 	if(target.value.length>0){
		// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
		// 	}
		// }

		this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
		if(target.value.length>0){
			this.setState({ OTPDisabled: "",passcodeDisabled:""});
		}
		
		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled:true
		});
		
	}

	userverifyIdChange(e){
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		// if(phoneRegx.test(target.value)){
		// 	this.setState({loginType:"mobile",loginMaxLength:10,isOTPSend:false,isVerified:false,OTPDisabled: "", passcodeDisabled:""});
		// }else{
		// 	this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});
		// 	if(target.value.length>0){
		// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
		// 	}
		// }

		this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});
		if(target.value.length>0){
			this.setState({ OTPDisabled: "",passcodeDisabled:""});
		}
		
		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled:true
		});
		//console.log(this.state);
	}
	
	enterOTPChange(e){
		if(this.otp.value.length > 0){
			this.setState({ verifyDisabled: ""});
		}else{
			this.setState({ verifyDisabled: "disabled"});
		}
		this.handleChange(e);
	}
	
	hmNav = function(){		
		//this.props.myProps.history.push(this.props.navigateURL);
		window.top.location.href = this.props.navigateURL;
	}
	
	submitForm = function(){		
		var verificationtype = this.state.loginType;
		
		var formData = {		
				"userId":this.state.userInput,	
				"password":this.state.password_newacc
		}
		//do cofirm
		var me =this;
		me.setState({submitButtonDisabled: true});
		var callBackSuccess = function(response){				
			console.log("response : ", response);				
			if(response !== null){
				me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});
				//console.log("timeout..........",me.state.pwdUpdated," : src = ",me.state.source);
				setTimeout(function(){
					console.log("timeout..........");
		  			me.bindLoginLink();
		  		},500);
				me.trackMe(true,"set_password");
				
			}else{
				me.trackMe(false,"set_password");
			}
		}

		var callBackFailure = function(response){
			me.setState({submitButtonDisabled: false});
			me.trackMe(false,"set_password");
		}

		new HmAjax(this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);
	}
	bindLoginLink(){
		var me = this;
		console.log("link::",$("#loginLink"));
		$("#loginLink").click(function(){
			me.showLogin();
		});
	}
	trackMe(result,source){			
		/*var trackObj = {
				"name": this.state.username_newacc,
			    "email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			    "phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);*/
		
		var trackObj = {
				"login_id":this.state.userInput,
				"email": "",
				"event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
		}

		if(source == "set_password") {
			this.storeTrackEvent("forgot_password", trackObj);
		} else {
			this.initiateTrack("forgot_password",trackObj);
		}
		
	}
	submitLumosPwdForm = function(){
		var me =this;	
		var formData = {
				"userId":this.state.username,
				"email":this.state.email
		}
		me.setState({submitButtonDisabled: true});
		$.ajax({
	            url: me.getUrlFor("LUMOS_FORGOTPWD"),
	            data: formData,
	            type: 'POST',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			 switch (response.code) {
			             case 200:
			            	//me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
			            	me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g, me.state.email));
			            break;
			            case 403:
			            	me.setState({submitButtonDisabled: false, serverMessage: fpServerResponses[response.code].replace(/<email>/g, me.state.email)});
			            break;
			            case 400:
			            case 401:
			            case 600:		              
			            	me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600] });
			            break;
			            default:
			              //currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
			            	me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
			          }
	    			 
	    			 me.trackMe();
	    		},
	            error: function(response){
	    			console.log("Error in lumos login",response);
	    			me.setState({submitButtonDisabled: false});
	    			me.trackMe();
	    		}
	    });
		
	}
	submitPLPPwdForm(){
		var userId = this.state.username;
		var emailId = this.state.email;
		
		if(this.state.UseridEmailidSame){
			userId = emailId
		}
		var formData = {
				"userId":userId,
				"emailId":emailId
		}

		var me =this;
		
		me.setState({submitButtonDisabled: true});
		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status == "SUCCESS"){
					//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
					
					me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g, formData.emailId));
				}
				else if(response.status == "INVALID_EMAIL"){
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
				}else if(response.status == "INVALID_USERID"){
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
				}else if(response.status == "PROVIDER_FORBIDDEN"){
					me.setState({ submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
				}
				else{
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
				}
			}
			me.trackMe();
			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			me.setState({submitButtonDisabled: false});
			me.trackMe();
		}

		new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
	}


	submitCommonPwdForm(){
		var userId = this.state.username;
		var emailId = this.state.email;
		
		if(this.state.UseridEmailidSame){
			userId = emailId
		}
		var formData = {
				"userId":userId,
				"email":emailId
		}

		var me =this;
		
		me.setState({submitButtonDisabled: true});
		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.source=="plp"){
					if(response.status == "SUCCESS"){
						//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.email)});
						
						me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g, formData.email));
					}
					else if(response.status == "INVALID_EMAIL"){
						me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
					}else if(response.status == "INVALID_USERID"){
						me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
					}else if(response.status == "PROVIDER_FORBIDDEN"){
						me.setState({ submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
					}
					else{
						me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
					}
				}else if(response.source=="lumos"){
					switch (response.code) {
						case 200:
						 //me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.email)});
						 me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g, me.state.email));
					 break;
					 case 403:
						 me.setState({submitButtonDisabled: false, serverMessage: fpServerResponses[response.code].replace(/<email>/g, me.state.email)});
					 break;
					 case 400:
					 case 401:
					 case 600:		              
						 me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600] });
					 break;
					 default:
						 //currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
						 me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
				 }
				}
			}
			me.trackMe();
			console.log("response : ", response);
		}

		var PLPcallBackFailure = function(response){
			me.setState({submitButtonDisabled: false});
			me.trackMe();
		}

		var callBackFailure = function(response){
			//me.setState({submitButtonDisabled: false});
			//me.trackMe();
			new NativeAjax(me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}

		//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, callBackFailure);
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid(), serverMessage: "" });

		if (this.form.isValid()) {   
			if(this.state.source.toLowerCase() == "lumos"){
				this.submitCommonPwdForm();
			}else if(this.state.isOTPSend && this.state.isVerified){
				this.submitForm();    
			}else if(this.state.source.toLowerCase() == "plp"){
				this.submitCommonPwdForm();
			}
		}
	}

	handleSubmitVerify(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.getUserStatus(); 
			// if(this.state.userLoginAllowed){
			// 	this.submitForm();  
			// }else{
			// 	this.getUserStatus();
			// }
		}
	}

	handleCheckboxChange(event){
		var target = event.target;		
		this.setState({"UseridEmailidSame":target.checked});
		if(event.target){
			this.setState({username:this.state.email})
		}
	}
	renderUseridEmailidValue(){
		if(this.state.UseridEmailidSame){			
			return this.state.email;
		}else{
			return this.state.username;
		}	
	}
	checkForDisabled(){
		return true;
		if(this.state.UseridEmailidSame){
			return true;
		}else{
			return false;
		}
	}
	
	sendOTP(){		
		// if(this.state.OTPDisabled == "hiddenOTP"){
		// 	this.form.validateFields();
		// 	return;
		// }
		
		var me =this;
		var otpServerMsg = "";
		
		if(this.state.loginType == "mobile"){
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to mobile";
			}else{
				otpServerMsg = "OTP is sent to your mobile";
			}
		}else{
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to your email";
			}else{
				otpServerMsg = "OTP is sent to your email";
			}
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});
				
		var formData = {
				"userId":this.state.userInput,				
				"contactType":this.state.loginType
		}		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",passcodeDisabled:""});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});
					}else if(response.status == "INVALID_EMAIL"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "INVALID_USERID"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "PROVIDER_FORBIDDEN"){
						me.setState({serverMessage: me.rb("google.errmsg.pwd"),passcodeDisabled:""});
					}
					else{
						me.setState({emailfeedbackmsg:otpServerMsg});
					}					
				}
				
				if(response.status.toLowerCase() == "success"){
					me.setState({isOTPSend:true,passcodeDisabled:"disabled"});
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}
						
			}

			console.log("response : ", response);
		}

		var PLPcallBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			me.setState({passcodeDisabled:""});
			me.trackMe(false,"send_otp");
		}

		var callBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			//me.setState({passcodeDisabled:""});
			//me.trackMe(false,"send_otp");
			new NativeAjax(me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}
		

		//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, callBackFailure);
	}
	verifyOTP(){
		var me =this;
		var formData = {
				"userId":this.state.userInput
		}
		
		me.setState({serverMessage:""});
		var verificationtype = this.state.loginType;
		this.setState({verifyDisabled:"disabled"});	
		var callBackSuccess = function(response){
			if(response !== null){
				
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "no_such_token" || response.status == "NO_TOKEN_AVAILABLE"){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.isValid == false){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}
					else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else{
						me.setState({isVerified:true,verifyDisabled: ""});
						me.trackMe(true,"verify_otp");
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in PWD_TOKEN_VALIDATE");	
			me.setState({verifyDisabled:""});
			me.trackMe(false,"verify_otp");
		}

		new HmAjax((this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc),formData).post(callBackSuccess,callBackFailure);
	}
	getOTPField(){
		if(this.state.isOTPSend){
			return(
					<FormGroup for="otp_newacc">
						<FormControlInput type="otp_newacc" className="otp_newacc" name="otp_newacc" placeholder={this.rb("register.enterOTP")}	
						innerRef={otp => this.otp = otp}
						onKeyUp={this.handleKeyUp}
						value={this.state.otp_newacc} onChange={this.enterOTPChange}
						required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
							<FieldFeedbacks for="otp_newacc">
						<FieldFeedback when="valueMissing">{this.rb("register.enterOTP")}</FieldFeedback>
						<FieldFeedback when="*" />
							</FieldFeedbacks>
					</FormGroup>
			);
		}
	}
	showLogin(){
		this.props.showNewLoginForm();
	}
	getVerifyField(){
		if(this.state.isOTPSend && !this.state.isVerified){
			return (<div className={"submitButton verifyButton "+this.state.verifyDisabled} onClick={this.verifyOTP} >{this.rb("register.verify")}</div>);
		}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/
		
	}
	getSignupHeaderMsg(){
		if(this.state.isOTPSend && !this.state.isVerified){
			if(this.state.loginType == "mobile"){
				return (
					<div>
						{/*<div><h4>Please verify your number</h4></div>*/}
						<div className="small infogrey mt-10">Please enter the 6-digit OTP sent to</div>
					</div>
				);
			}else{
				return (
					<div>
						{/*<div><h4>Please verify your Email</h4></div>*/}
						<div className="small infogrey mt-10">Please enter the 6-digit OTP sent to</div>
					</div>
				);
			}
			
		}else if(this.state.isVerified){
			if(this.state.loginType == "mobile"){
				return (
					<div>
						{/*<div><h4>Congratulations</h4></div>*/}
						<div className="small infogrey mt-10">You have requested to reset the password for</div>
						<div className="small mt-10">+91 {this.state.userInput}</div>
					</div>
				);
			}else{
				return (
					<div>
						{/*<div><h4>Congratulations</h4></div>*/}
						<div className="small infogrey mt-10">You have requested to reset the password for</div>
						<div className="small mt-10">{this.state.userInput}</div>
					</div>
				);
			}
		}
		
	}
	sendOTPText(){
		if(this.state.isOTPSend){
			return(this.rb("register.reSendOTP"));
		}else{
			return(this.rb("home.continue"));
		}
	}
	showEmailFeedback(){
		if(this.state.isOTPSend){
			return(
				<div className="form-control-feedback">
					<div className="error">{this.state.emailfeedbackmsg}</div>
					{( () =>{
						if(this.state.loginType == "mobile"){
							return(
									<div className="feedbacksmall"><i>All important information will be sent to this mobile number</i></div>
							);
						}else{
							return(
									<div className="feedbacksmall"><i>All important information will be sent to this email ID</i></div>
							);
						}
					})()}
					
				</div>
			);
		}
	}
	
	getUserInputPattern(){		
		if(this.state.loginType == "mobile"){
			return ".{10,}";
		}else{
			return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
		}
	}
	getContactType(){
		if(!this.state.isVerified){
			return(
				<div>
					{(()=>{
								if(!this.state.isOTPSend){
									return(
										<div className="small infogrey mt-10 textAlignLeft">{this.rb("unifiedlogin.otpalert")}{this.state.loginType == "mobile" ? "mobile no":"email"}</div>
									)
								}
							})()}
					<FormGroup for="userInput">
						{( () => {
							if(this.state.loginType == "mobile"){
								return (
									<span className="countrycodeform">+91</span>
								);
							}
						})()}

						<FormControlInput type="userInput" className={"userInput "+this.state.loginType} name="userInput" placeholder={this.rb("login.userplaceholder.za")}
							innerRef={email => this.email = email}
							onKeyUp={this.handleKeyUp}
							value={this.state.userInput} onChange={this.userIdChange} disabled={this.checkForDisabled()}
							pattern={this.getUserInputPattern()}
							required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
							
						
							{( () => {
								if(this.state.loginType == "mobile"){
									return (
										<FieldFeedbacks for="userInput">
											<FieldFeedback when="valueMissing">{this.rb("za_login.useridrequired")}</FieldFeedback>
											<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
											 <FieldFeedback when={value => (value.length>0 && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
											<FieldFeedback when="*" />
										</FieldFeedbacks>
									);
								}else{
									return (
										<FieldFeedbacks for="userInput">
											<FieldFeedback when="valueMissing">{this.rb("za_login.useridrequired")}</FieldFeedback>
											{/*<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>*/}														
										</FieldFeedbacks>	
									);
								}
							})()}
							
							{/*<FieldFeedback when="valueMissing">{this.rb("za_login.useridrequired")}</FieldFeedback>
							<FieldFeedback when="*" />*/}
						
					</FormGroup>
						
					{/*<div className="clearfix">
						<div className="emailfeedback">
							{this.showEmailFeedback()}				
						</div>
					</div>*/}
				
				
				
					<div className="clear clearfix"></div>
					
					{this.getOTPField()}				
							
					<div className="clear clearfix"></div>
				
					<div className="server-messages pb-20">{this.state.serverMessage}</div>
										
					
					{( () => {
						
							if(this.state.isOTPSend){
								return(
								<div>									
									<div className="clearfix">
										<span>{this.rb("register.reSendOTPmsg")} </span> <span className="pl-10 resendButton" onClick={this.sendOTP}>{this.rb("register.reSendOTP")}</span>
									</div>
									{this.getVerifyField()}
								</div>
								);
							}else{
								return(
									<div>
										{this.getVerifyField()}
										<div>
										<div className={"submitButton OTPButton "+this.state.OTPDisabled+" "+this.state.passcodeDisabled} onClick={this.sendOTP} >{this.rb("home.continue")}</div>
										</div>
									</div>
								);
							}
						
					})()}
				</div>
			);
		}
	}
	setPassword(){
		if(this.state.isVerified){
			return(
				<div>					
					<FormGroup for="password_newacc">
						<FormControlInput type="password" className="password_newacc" name="password_newacc" placeholder={this.rb("login.password")}						
						innerRef={password => this.password = password}
						value={this.state.password_newacc} onChange={this.handleChange}
						required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
						<FieldFeedbacks for="password_newacc">
						<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
						<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
						</FieldFeedbacks>
					</FormGroup>
					
					<FormGroup for="confirmpassword">
						<FormControlInput type="password" className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
							innerRef={confirmpassword => this.confirmpassword = confirmpassword}
						value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
						required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />
						
						<FieldFeedbacks for="confirmpassword_newacc">
							<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
							<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
							<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
						</FieldFeedbacks>					
					</FormGroup>
					
					<div className="clear clearfix"></div>
				
					<div className="server-messages pt-20">{this.state.serverMessage}</div>
				</div>
			);
		}
	}
	renderRHSForm(){
		if(this.state.pwdUpdated === true && this.state.source === "plp"){
			return(					
					<div className="row">
						<div className="col-md-12 mt-50">{ReactHtmlParser(this.rb("rpwd.msg.success"))}</div>
					</div>
			);
		}else if(this.state.pwdUpdated === true && this.state.source === "lumos"){
				return(					
					<div className="row">
						<div className="col-md-12 mt-50">{ReactHtmlParser(this.rb("rpwd.msg.success"))}</div>
					</div>
				);
			}else{
			return(
				<div className="">
					
					<div className="row">
					<div className="col-md-12">
	
					<div className="row">
					<div className="col-md-12 mx-auto">
					<div className="rounded-0">

					{this.getSignupHeaderMsg()}
						
						<div className="text-center ">
						
						<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
						onSubmit={this.handleSubmit} noValidate>
							{this.getContactType()}						
							{this.setPassword()}
							<button data-ga="Home - Sign in - Users who want to register - Sign Up" disabled={this.state.submitButtonDisabled} className={"submitButton signup signupButton "+(this.state.isVerified ? "" : "hidden")}>{this.rb("register.setpassword")}</button>
						</FormWithConstraints>	
						
						
						</div>
					</div>
					</div>
	
	
					</div>
	
					</div>
					</div>
					
				</div>
			);
		}
	}
	renderFormTitle(){
		if(this.state.isOTPSend && this.state.isVerified){
			return this.rb("rpwd.title");
		}else{
			return this.rb("forgot_password_label");
		}
	}
	handleKeyUp(event) {
	    if (event.key === 'Enter' && this.form.isValid()) {	    	
	      if(!this.state.isVerified){
	    	  if(this.state.isOTPSend && this.state.verifyDisabled != "disabled"){
	    		 $(".verifyButton").trigger("click");
	    	  }else if(this.state.passcodeDisabled != "disabled"){
				this.setState({ OTPDisabled: ""});
				$(".OTPButton").trigger("click");				
	    	  }
	      }
	      
	    }
	}

	lumosForgotPassword(){
		
			 if(this.state.loggedIn){
				return super.render();
				} else { return (
						<div className="container">
						
						<div>
							<div className="text-center schoolLoginInfo josefinsansFont nopadding">
								{this.rb("unif.fpwd.msg1")}
								<br />
								{/* {this.rb("fpwd.msg2")}
								<br /> */}
								
								{(() => {
									 if(this.props.source.toLowerCase() == "lumos"){
										 return(
											 <div className="text-center schoolLoginInfo josefinsansFont">
												 {ReactHtmlParser(this.rb("fpwd.lumos.msg"))}
											 </div>	
										 );
									 }										 				
								 })()}
								
							</div>
						</div>
					
						<div className="row">
						<div className="col-md-12">
		
							<div className="row">
								<div className="col-md-12 nopadding">
									<div className="rounded-0">
										<div className="text-center">
										
											<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
											onSubmit={this.handleSubmit} noValidate>
											
												
												
												<FormGroup for="username">
													<FormControlInput type="username" className="username" name="username" placeholder={this.rb("login.userid")}
														value={this.renderUseridEmailidValue()} onChange={this.handleChange} disabled={this.checkForDisabled()}
													required minLength={1} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
														<FieldFeedbacks for="username">
													<FieldFeedback when="valueMissing">{this.rb("za_login.useridrequired")}</FieldFeedback>
													<FieldFeedback when="*" />
														</FieldFeedbacks>
												</FormGroup>

												<FormGroup for="email">
													<FormControlInput type="email" className="email" name="email" placeholder={this.rb("fpwd.email")}
														innerRef={email => this.email = email}
													value={this.state.email} onChange={this.handleemailChange}				
													required maxLength={254} pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$" minLength={1} tabIndex="1"/>
													
													<FieldFeedbacks for="email" show="all">
														<FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
														<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
													</FieldFeedbacks>					
												</FormGroup>
												
												{(() => {
													 if(this.props.source.toLowerCase() == "plp"){
														 return(
																 <div className="text-left">
																	 <label className="checkboxLabel">							 							
																	  <input
																		className="fwdCheckbox"
																		name="sameUseridEmailid"
																		type="checkbox"												           
																		onChange={this.handleCheckboxChange} />
																	  {this.rb("fpwd.plp.useridemailidsame")}
																	</label>
																</div>
														 );
													 }										 				
												 })()}
											
												<div className="forgotpwdMsg">
													<div className="server-messages"> {ReactHtmlParser(this.state.serverMessage)}</div>	
												</div>
												
												<button disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("login.send")}</button>										
											</FormWithConstraints>	
										</div>
									</div>
								</div>
							</div>
							
							{(() => {
								 if(this.props.source.toLowerCase() == "plp"){
									 return(
										 <div className="text-center schoolLoginInfo josefinsansFont">
											 {this.rb("fpwd.plp.note")}
										 </div>	
									 );
								 }										 				
							 })()}
							
							<br />
						</div>
						
						</div>
						</div>
			 );} 
			
	}
	plpForgotPassword() {
			var me=this;
			if(this.state.loggedIn){
				return super.render();
			} else { return me.renderRHSForm(); } 
	}

	commonForgotPassword(){
		var me=this;
		
		if(this.state.loggedIn){
			return super.render();
		} else {
			return me.userVerify();
		}
	}
	userVerify(){
		
			var me=this;
			if(this.state.loggedIn){
				return super.render();
			} else { return ( 
					<div>					
						<div className="col-md-12 mx-auto">											
							<div className="text-center ">	
								<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
								onSubmit={this.handleSubmitVerify} noValidate>

								<FormGroup for="plp_userinput">
								{/* {( () => {
									if(this.state.loginType == "mobile"){
										return (
											<span className="countrycode">+91</span>
											);
									}
								})()} */}

								<FormControlInput type="plp_userinput" className={"plp_userinput "+this.state.loginType} name="plp_userinput" placeholder={this.rb("unifiedlogin.userplaceholder")}
								value={this.state.plp_userinput} onChange={this.userverifyIdChange}
								required minLength={1} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>

								<FieldFeedbacks for="plp_userinput">
								<FieldFeedback when="valueMissing">{this.rb("za_unifiedverify.useridrequired")}</FieldFeedback>
								<FieldFeedback when="*" />
								</FieldFeedbacks>
								</FormGroup>
								<div className="server-messages">{this.state.serverMessage}</div>

								<button data-ga={"Home - Verify"} className="submitButton">Verify</button>
								</FormWithConstraints>	
							</div>						
						</div>
					</div>
			);}                  
		
	}
	getUserStatus(){
		if(this.state.plp_userinput.length<=0){
			return;
		} 
		
		var formData = {
			"userId":this.state.plp_userinput
		}

		var me =this;
		var callBackSuccess = function(response, request){
			
			if(response !== null){
			if(response.userExists && response.source!=='null' && response.message !== "provider_forbidden"){	
				if(response.source=="lumos"){
					me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.plp_userinput});
				}else if(response.source=="plp"){
					me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.plp_userinput});
				}
			}else{	
				if(response.message == "provider_forbidden"){						
					if(response.authProviderId==2){
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
					}else if(response.authProviderId==4){
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("uolo.errmsg.pwd")});
					}
				}else{					
					//me.setState({userLoginAllowed:false});
					//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
					me.setState({submitButtonDisabled: false, serverMessage: me.rb("za_unifiedlogin.invalidinput.msg")});
				//	me.checkValidUserInput();
				}					
			}
		}

			
		}

		var PLPcallBackFailure = function(response, request){
					
			me.setState({submitButtonDisabled: false});


		}

		var callBackFailure = function(response, request){	
			//me.setState({submitButtonDisabled: false});
			new NativeAjax(me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}

		//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess, callBackFailure);
		
	}
	checkValidUserInput(){
		var me = this;
		var userinput = this.state.plp_userinput;

		if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
			me.setState({userLoginAllowed:false});
			me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
		}else{
			me.setState({submitButtonDisabled: false, serverMessage: me.rb("za_login.invalidinput.msg")});
		}
		// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		// if(phoneRegx.test(userinput)){			
		// 	if(userinput.length == 10){				
		// 		me.setState({userLoginAllowed:false});
		// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
		// 	}else{
		// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
		// 	}
		// }else{
		// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
		// 		me.setState({userLoginAllowed:false});
		// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
		// 	}else{
		// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
		// 	}
		// }
	}

	forgotPassword(){
		var me=this;
		if(this.state.source===''){
			return	me.commonForgotPassword()
		}else if(this.state.source==='plp'){
			return me.plpForgotPassword()
		}else if(this.state.source==='lumos'){
			return me.lumosForgotPassword()
		}
	}

	render () {
		return(
			<div className="row nomargin loginParent">
			<div className="col-sm-4 nopadding loginLeftSection">
				<h2 className="loginLeftContent">{this.renderFormTitle()}</h2>
				<div className="charactercontainer d-none d-sm-block">
					<img className="charactericons forgotpwdIcon" src={forgotpwdIcon} />
				</div>
			</div>
			
			<div id="loginRoot" className="plpLogin col-sm-8">
			 {this.forgotPassword()}				
			</div>
		</div>
		)
	}
}

export default UnifiedForgotPwd;



// WEBPACK FOOTER //
// ./src/views/sg/sg_UnifiedForgotPwd.js